import { render, staticRenderFns } from "./SecurityComponent.vue?vue&type=template&id=0aca3c25&scoped=true&"
import script from "./SecurityComponent.vue?vue&type=script&lang=ts&"
export * from "./SecurityComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SecurityComponent.vue?vue&type=style&index=0&id=0aca3c25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aca3c25",
  null
  
)

export default component.exports